import { useCallback, useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';

import UserService from 'src/services/UserSevice';

export default function TelegramOnboardingConnect({ initialConnected }: { initialConnected: boolean }) {
    const [connected, setConnected] = useState(initialConnected);
    const [bindLink, setBindLink] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const refresh = useCallback(async () => {
        try {
            const result = await UserService.getTelegramBindLink();
            if (!result?.telegram_bind_link?.startsWith('https://t.me/')) {
                throw new Error('telegram_bind_link_unavailable');
            }
            setConnected(result.is_telegram_connected === true);
            setBindLink(result.telegram_bind_link);
            setError(false);
        } catch {
            setError(true);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        void refresh();
        const onFocus = () => void refresh();
        const onVisible = () => {
            if (document.visibilityState === 'visible') void refresh();
        };
        window.addEventListener('focus', onFocus);
        document.addEventListener('visibilitychange', onVisible);
        return () => {
            window.removeEventListener('focus', onFocus);
            document.removeEventListener('visibilitychange', onVisible);
        };
    }, [refresh]);

    return (
        <Box
            component="section"
            aria-label="Подключение Telegram"
            sx={{ mt: 2, mb: 2, p: 2, bgcolor: 'var(--lm-surface)', borderRadius: 3 }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, flexWrap: 'wrap' }}>
                    <Typography variant="h3" color="text.primary" sx={{ fontWeight: 600, mb: 0 }}>
                        Доставка лидов в Telegram
                    </Typography>
                    <Typography variant="body2" color="text.secondary">Необязательно</Typography>
                </Box>
                {connected ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                        <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: 'var(--lm-success-ink)' }} />
                        <Typography variant="body2" sx={{ color: 'var(--lm-success-ink)', fontWeight: 500 }}>
                            Telegram подключён
                        </Typography>
                    </Box>
                ) : error ? (
                    <Button type="button" variant="outlined" onClick={() => void refresh()}>
                        Повторить
                    </Button>
                ) : (
                    <Button
                        component="a"
                        href={bindLink || undefined}
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="contained"
                        color="primary"
                        disabled={loading || !bindLink}
                    >
                        Подключить Telegram
                    </Button>
                )}
            </Box>
            {!connected && (
                <Typography variant="body2" color={error ? 'error' : 'text.secondary'} sx={{ mt: 1 }}>
                    {error
                        ? 'Не удалось получить ссылку на бот.'
                        : 'Подключите бот, чтобы получать уведомления о новых лидах. Это можно сделать позже.'}
                </Typography>
            )}
        </Box>
    );
}
